import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["tabindex", "data-test"]

import { ref, reactive, onMounted } from 'vue'
import { TimelineItem } from './types'

interface Props {
  data: TimelineItem
  isVisible: boolean
  isActive: boolean
  index: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineStop',
  props: {
    data: null,
    isVisible: { type: Boolean },
    isActive: { type: Boolean },
    index: null
  },
  emits: ["labelClicked"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'labelClicked', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: TimelineItem
  isVisible: boolean
  isActive: boolean
  index: number
}



// eslint-disable-next-line @typescript-eslint/no-unused-vars

const element = ref(null)
const state = reactive({
  element: null,
})

expose({ state })

const handleLabelClicked = (evt) => {
  emit('labelClicked', props.index)
  evt.stopPropagation()
}

onMounted(() => {
  state.element = element.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: "absolute",
    style: _normalizeStyle({
      left: props.data.percentage + '%',
    })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["relative -left-5px -top-5px w-10px h-10px rounded-full", props.isActive ? 'bg-poppy' : 'bg-white'])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["relative -left-px h-60px border-l-2 border-solid border-white", `${props.data.pointsUp ? '-top-70px' : '-top-10px'} ${
        props.isActive ? 'border-poppy' : 'border-white'
      }`])
    }, null, 2),
    _createElementVNode("button", {
      class: _normalizeClass(["absolute text-headingSm text-white hover:text-poppy -rotate-45", `${
        props.data.pointsUp
          ? '-top-100px text-left -left-2'
          : 'top-70px text-right right-1'
      } ${props.isActive ? 'text-poppy font-extrabold' : 'text-white'}`]),
      tabindex: props.isVisible ? 10 * (props.index + 1) : -1,
      "data-test": `timeline-stop-label-${props.index}`,
      onClick: handleLabelClicked
    }, _toDisplayString(props.data.year), 11, _hoisted_1)
  ], 4))
}
}

})